module.exports = __webpack_public_path__ + "static/media/thumbnail.8e90c651.png";